<script setup>
import {computed} from "vue";
import TableCell from "@/components/global-themed/table/TableCell.vue";
import TableRow from "@/components/global-themed/table/TableRow.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import CustomToggle from "@/components/global-themed/CustomToggle.vue";
import DeleteBannerButton from "@/components/admin/banners/DeleteBannerButton.vue";

const props = defineProps({
  banner: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['toggle-active']);

const previewImage = computed(() => {
  return props.banner.images.large ?? props.banner.images.medium ?? props.banner.images.small ?? null;
});

const editUri = computed(() => `/admin/banners/${props.banner.id}/edit`);
</script>

<template>
  <TableRow>
    <TableCell col-span="2">
      <img
        v-if="previewImage"
        :src="previewImage"
        alt=""
        class="tw-w-24 tw-h-12 tw-object-cover tw-rounded"
      >
      <div
        v-else
        class="tw-w-24 tw-h-12 tw-bg-neutral-100 tw-rounded tw-flex tw-items-center tw-justify-center tw-text-xs tw-text-grey-dark"
      >
        No image
      </div>
    </TableCell>

    <TableCell
      col-span="4"
      class="tw-flex tw-items-center tw-font-medium tw-text-neutral-900"
    >
      {{ banner.title }}
    </TableCell>

    <TableCell
      col-span="3"
      class="tw-flex tw-items-center tw-truncate"
    >
      <a
        v-if="banner.cta_url"
        :href="banner.cta_url"
        target="_blank"
        rel="noopener noreferrer"
        class="tw-text-blue tw-underline tw-truncate"
      >
        {{ banner.cta_url }}
      </a>
      <span v-else>—</span>
    </TableCell>

    <TableCell
      col-span="1"
      class="tw-flex tw-items-center tw-justify-center"
    >
      <CustomToggle
        :model-value="banner.active"
        @update:model-value="emit('toggle-active', banner)"
      />
    </TableCell>

    <TableCell
      col-span="2"
      class="tw-flex tw-gap-3 tw-justify-center"
    >
      <DefaultButton
        variant="primary-inverted"
        size="small"
        as="a"
        :href="editUri"
      >
        <svg-vue
          icon="icons/pen"
          class="tw-w-5 tw-h-5"
        />
        <span class="tw-font-semibold tw-antialiased">Edit</span>
      </DefaultButton>

      <DeleteBannerButton
        :banner="banner"
      />
    </TableCell>
  </TableRow>
</template>
